var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        width: 800,
        visible: _vm.visible,
        maskClosable: false,
        confirmLoading: _vm.confirmLoading,
        cancelText: "关闭",
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form",
            { attrs: { form: _vm.form } },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: "职务编码",
                  },
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["code", _vm.validatorRules.code],
                        expression: "['code', validatorRules.code]",
                      },
                    ],
                    attrs: { placeholder: "请输入职务编码" },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: "职务名称",
                  },
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["name", _vm.validatorRules.name],
                        expression: "['name', validatorRules.name]",
                      },
                    ],
                    attrs: { placeholder: "请输入职务名称" },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                    label: "职级",
                  },
                },
                [
                  _c("j-dict-select-tag", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["postRank", _vm.validatorRules.postRank],
                        expression: "['postRank', validatorRules.postRank]",
                      },
                    ],
                    attrs: {
                      placeholder: "请选择职级",
                      triggerChange: true,
                      dictCode: "position_rank",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }